module.exports = __webpack_public_path__ + "img/lianyungang.ef4d9ab2.jpg";